import {
  GeckoBinnedDataBuffer,
  serializeBinnedDataBuffer,
} from 'features/dataLayers/geckoBinnedDataBuffer'
import isNil from 'lodash/isNil'

// eslint-disable-next-line boundaries/no-unknown
import QuantitativeDataStatsWorker from './generateQuantitativeDataStats.worker?worker'
import {
  deserializeQuantitativeSummaryStatistics,
  QuantitativeSummaryStatistics,
  RawQuantitativeSummaryStatistics,
} from './quantitativeStatisticsDataType'

/**
 *  Returns statistics about data in the given measurement units, include
 *  - maximum reading, also indicates the ceiling of the last bin
 *  - minimum reading, also indicates the floor of the first bin
 *  - mean reading
 *  - standard deviation of distribution
 *  - histogram bins where each bin is formatted as [bin index, number of readings];
 *    if finite and defined values are uniform, then histogram is undefined
 * Note that values on the boundary of bins may be assigned non-deterministically
 * to the previous or following bin due to floating point error. However, this
 * should be of little concern since this function merely returns an approximation
 * of the distribution.
 *  * @param binnedDataBuffer a class that houses the values for a given data-layer
 */
export const generateQuantitativeDataStats = (
  binnedDataBuffer: GeckoBinnedDataBuffer
) =>
  new Promise<QuantitativeSummaryStatistics | undefined>((resolve, reject) => {
    try {
      const worker = new QuantitativeDataStatsWorker()
      worker.onmessage = async (
        message: MessageEvent<RawQuantitativeSummaryStatistics | undefined>
      ) => {
        worker.terminate()
        const data = !isNil(message.data)
          ? deserializeQuantitativeSummaryStatistics(message.data)
          : undefined
        resolve(data)
      }

      worker.onerror = async (error) => {
        console.error(error)
        worker.terminate()
        reject(`Couldn't generate CDF statistics, ${error}`)
      }
      worker.postMessage(serializeBinnedDataBuffer(binnedDataBuffer))
    } catch (error) {
      reject(`Couldn't generate CDF statistics, ${error}`)
      console.error(error)
    }
  })
